import * as angular from 'angular';

class ConnectionController {}

export const ConnectionComponent: angular.IComponentOptions = {
  controller: ConnectionController,
  controllerAs: 'ctrl',
  bindings: {},
  template: '<div ui-view />',
};
